export default __webpack_public_path__ + "static/media/P&m.c544b49e.jpg";